module.exports = __webpack_public_path__ + "static/media/home-1.0b573a6a.png";